import Marquee from "react-fast-marquee";

const items = [
  "Mario Auto Body",
  "Expert Collision Repair",
  "Jessup, MD",
  "Dent & Paint Repair",
  "Bumper Repair",
  "Damage Assessment",
];

export const EditorialMarquee = () => (
  <div className="border-y border-white/10 py-5 bg-black" data-testid="editorial-marquee">
    <Marquee speed={30} gradient={false}>
      {items.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display text-2xl md:text-3xl uppercase tracking-widest text-zinc-600 mx-8">{t}</span>
          <span className="w-2 h-2 bg-[#E60000]" />
        </span>
      ))}
    </Marquee>
  </div>
);
